import React, { useState } from 'react';
import { Button } from '../Button/Button';
import { handleError, handleSuccess } from '../../model/notification';
import { TextField } from '../Form/TextField/TextField';
import { Card } from '../Card/Card';

export function NotificationExample(): JSX.Element {
  const [closeNotification, setCloseNotification] = useState(3000);

  function throwError(): void {
    handleError(new Error('this is an error'));
  }
  function throwSuccess(): void {
    handleSuccess(
      'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Recusandae omnis enim repudiandae autem aliquam architecto quas numquam ab tenetur similique sapiente, expedita eius repellat cumque voluptatum. Et, enim. Praesentium, veniam.'
    );
  }
  function showNotification(): void {
    handleSuccess(
      `This message will self destruct in ${Math.round(closeNotification / 1000)} seconds`,
      closeNotification
    );
  }

  return (
    <div>
      <div style={{ marginBottom: '10px ' }}>
        <Button title="Throw Error" onClick={throwError} type="primary" />
      </div>
      <div style={{ marginBottom: '10px ' }}>
        <Button title="Throw Success" onClick={throwSuccess} type="primary" />
      </div>
      <div>
        <Card size="small" title="Notification with timeout">
          <TextField
            value={Math.round(closeNotification / 1000)}
            label="Timeout"
            type="number"
            onChange={(e) => setCloseNotification(Number(e) * 1000)}
          ></TextField>
          <Button title="Show notification" onClick={showNotification} type="primary" />
        </Card>
      </div>
    </div>
  );
}
